"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubscriptionProductType = void 0;
exports.ESubscriptionProductType = {
    pleine_propriete: "pleine_propriete",
    nue_propriete: "nue_propriete",
    usufruit: "usufruit",
};
